/**
 * useGroupVariants Hook
 *
 * Batch-fetches the variants for a list of product IDs in a single request and
 * returns a map keyed by product ID plus a flat list of every variant ID in the
 * group (used for radio-group exclusivity).
 *
 * @package
 */

import { useApiCache } from './useApiCache';

/**
 * @param {Array} productIds Product IDs in the group.
 * @return {Object} { variantsMap, groupVariantIds, loading }
 */
export const useGroupVariants = productIds => {
	const ids = Array.isArray( productIds )
		? productIds.map( id => parseInt( id, 10 ) ).filter( id => id > 0 )
		: [];

	// Stable cache key regardless of ordering.
	const key = ids.slice().sort( ( a, b ) => a - b ).join( ',' );
	const path = key ? `/at-configurator/v1/products/variants?ids=${ key }` : null;

	const { data, loading } = useApiCache( path, { enabled: !! key } );

	const variantsMap = data && typeof data === 'object' ? data : {};

	const groupVariantIds = [];
	Object.values( variantsMap ).forEach( list => {
		if ( Array.isArray( list ) ) {
			list.forEach( v => groupVariantIds.push( v.id ) );
		}
	} );

	return { variantsMap, groupVariantIds, loading };
};
